import { StateCreator } from 'zustand'

import { CombinedZustandSlices, CreateQuoteSlice, Quote } from '../types'

const emptyQuoteData: Quote = {
  generalInfo: {
    referralCode: undefined,
    directLead: undefined,
    impactClickId: undefined,
    utmSource: undefined,
    matchedQuoteId: undefined,
    matchedQuoteChannel: undefined,
    requiredAdditionalQuestions: undefined,
  },
  formProgress: [],
  pageState: {},
  meta: {
    createdAt: new Date().toISOString(),
  },
}

export const createQuoteSlice: StateCreator<CombinedZustandSlices, [], [], CreateQuoteSlice> = (
  set,
  get,
) => ({
  directQuotes: {},
  createQuote: (quoteId, data) =>
    set(({ directQuotes }) => {
      const { formProgress = emptyQuoteData.formProgress, pageState = emptyQuoteData.pageState } =
        data
      const newQuote: Quote = {
        generalInfo: {
          ...emptyQuoteData.generalInfo,
          ...data.generalInfo,
        },
        formProgress,
        pageState,
        meta: {
          createdAt: new Date().toISOString(),
        },
      }

      return {
        directQuotes: {
          ...directQuotes,
          [quoteId]: newQuote,
        },
      }
    }),
  getQuoteStepData: (quoteId, stepName) => {
    const quoteData = get().directQuotes[quoteId]

    if (!quoteData || (stepName && !quoteData.pageState[stepName])) {
      return null
    }

    if (!stepName) {
      return quoteData.pageState
    }

    return quoteData.pageState[stepName]
  },

  getQuoteData: (quoteId, quoteSection) => {
    const quoteData = get().directQuotes[quoteId]

    if (!quoteData || (quoteSection && !quoteData[quoteSection])) {
      return null
    }

    if (quoteSection) {
      return quoteData[quoteSection]
    }

    return quoteData
  },
  deleteQuote: (quoteId) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { [quoteId]: _, ...directQuotes } = get().directQuotes
    set({ directQuotes })
  },
  updateQuoteGeneralInfo: (quoteId, data) =>
    set(({ directQuotes }) => ({
      directQuotes: {
        ...directQuotes,
        [quoteId]: {
          ...directQuotes[quoteId],
          generalInfo: { ...directQuotes[quoteId]?.generalInfo, ...data },
        },
      },
    })),
  completeQuoteStep: (quoteId, step, data) =>
    set(({ directQuotes }) => {
      const currentFormProgress = directQuotes[quoteId]?.formProgress ?? []

      return {
        directQuotes: {
          ...directQuotes,
          [quoteId]: {
            ...directQuotes[quoteId],
            formProgress: currentFormProgress.includes(step)
              ? currentFormProgress
              : [...currentFormProgress, step],

            pageState: { ...directQuotes[quoteId].pageState, [step]: data },
          },
        },
      }
    }),
  updateQuoteStepData: (quoteId, step, data) =>
    set(({ directQuotes }) => ({
      directQuotes: {
        ...directQuotes,
        [quoteId]: {
          ...directQuotes[quoteId],
          pageState: { ...directQuotes[quoteId].pageState, [step]: data },
        },
      },
    })),
  updateQuoteStep: (quoteId, step) =>
    set(({ directQuotes }) => {
      const currentFormProgress = directQuotes[quoteId]?.formProgress ?? []

      return {
        directQuotes: {
          ...directQuotes,
          [quoteId]: {
            ...directQuotes[quoteId],
            formProgress: currentFormProgress.includes(step)
              ? currentFormProgress
              : [...currentFormProgress, step],
          },
        },
      }
    }),
})
